import { BONDS_STORE_NAME } from '@/creditflowresearch/application/Bonds/constants';
import DatePeriod from '@framework/ui/Organisms/Filters/FiltersPanel/DatePeriod';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';
import { useBondsFiltersContext } from '@/creditflowresearch/application/Bonds/BondsFiltersContext';

const DatePeriodContainer = (props) => {
  const { getFilters } = useFiltersContext();
  const filters = getFilters(BONDS_STORE_NAME);
  const { dateFromMin, dateToMax } = useBondsFiltersContext();

  const isFilterExists = !!filters;

  const dateFrom = isFilterExists ? filters.dateFrom : null;
  const dateTo = isFilterExists ? filters.dateTo : null;

  return (
    <DatePeriod
      { ...props }
      dateFromMin={ dateFromMin }
      dateToMax={ dateToMax }
      dateFrom={ dateFrom }
      dateTo={ dateTo }
    />
  );
};

export default DatePeriodContainer;
